module.exports = ol.geom.SimpleGeometry;